export default {
  orsDictionary: {
    'unknown': 'Sconosciuto',
    'paved': 'Pavimentato',
    'unpaved': 'Non pavimentato',
    'asphalt': 'Asfalto',
    'concrete': 'Calcestruzzo',
    'cobblestone': 'Ciottolo',
    'metal': 'Metallo',
    'wood': 'Legno',
    'compactedGravel': 'Ghiaia compatta',
    'fineGravel': 'Ghiaia sottile',
    'gravel': 'Ghiaia',
    'dirt': 'Polvere',
    'ground': 'Terreno',
    'ice': 'Ghiaccio',
    'pavingStones': 'Pietra pavimentata',
    'sand': 'Sabbia',
    'woodchips': 'Trucioli di legno',
    'grass': 'Erba',
    'grassPaver': 'Pavimentazione da prato',
    'none': 'Nessuno',
    'no': 'No',
    'customers': 'Accesso clienti',
    'destination': 'Destinazione',
    'delivery': 'Zona di carico/scarico',
    'private': 'Privato',
    'permissive': 'Permesso',
    'stateRoad': 'Strada statale',
    'road': 'Strada',
    'street': 'Strada',
    'path': 'Sentiero',
    'track': 'Tracciato',
    'cycleway': 'Pista ciclabile',
    'footway': 'Passaggio pedonale',
    'steps': 'Gradini',
    'ferry': 'Traghetto',
    'construction': 'In costruzione',
    'concrete:lanes': 'Stradine in cemento',
    'paving_stones': 'Pietra pavimentata',
    'sett': 'Pavè',
    'unhewn_cobblestone': 'Ciottolo grezzo',
    'compacted': 'Compattato',
    'fine_gravel': 'Ghiaia sottile',
    'pebblestone': 'Ciottolo',
    'impassable': 'Impraticabile',
    'very_horrible': 'Molto disastroso',
    'horrible': 'Disastroso',
    'very_bad': 'Molto cattivo',
    'bad': 'Cattivo',
    'intermediate': 'Medio',
    'good': 'Buono',
    'excellent': 'Eccellente',
    'grade1': 'Grado 1',
    'grade2': 'Grado 2',
    'grade3': 'Grado 3',
    'grade4': 'Grado 4',
    'grade5': 'Grado 5',

    'no_tollway': 'Senza pedaggio',
    'is_tollway': 'Pedaggio',
    'no_category': 'Nessuna categoria',
    'highway': 'Autostrada',
    'unpaved_road': 'Non asfaltata',
    'tunnel':	'Tunnel',
    'paved_road':	'Asfaltata',
    'ford': 'Guado',
    'no_data': 'Nessun dato'
  }
}
